// extracted by mini-css-extract-plugin
export default {"modalWrapper":"confirmModal_modalWrapper__byQdi","modal":"confirmModal_modal__Vhpcx","fadeInDown":"confirmModal_fadeInDown__L2ecN"};